import { render, staticRenderFns } from "./IsvList.vue?vue&type=template&id=45d36a00"
import script from "./IsvList.vue?vue&type=script&lang=js"
export * from "./IsvList.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports